module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "xz7bf92j",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
};
